import beworks from './beworks';
import gm from './gm';

export const brands = { beworks, gm };

export const DEFAULT_BRAND = 'beworks';

// Chave ausente ou desconhecida cai na marca padrão.
export function getBrand(key) {
  return brands[key] ?? brands[DEFAULT_BRAND];
}
